/**
 * Division Toggle Component
 * Switches between Residential and Government CRM views
 */

import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

interface DivisionToggleProps {
  className?: string;
}

const DivisionToggle: React.FC<DivisionToggleProps> = ({ className = '' }) => {
  const navigate = useNavigate();
  const location = useLocation();
  
  // Determine current division based on URL path
  const isGovernment = location.pathname.startsWith('/gov');
  
  const handleToggle = (division: 'residential' | 'government') => {
    if (division === 'government' && !isGovernment) {
      navigate('/gov/solicitations');
    } else if (division === 'residential' && isGovernment) {
      navigate('/');
    }
  };

  return (
    <div className={`division-toggle ${className}`} style={styles.container}>
      <button
        onClick={() => handleToggle('residential')}
        style={{
          ...styles.button,
          ...(isGovernment ? styles.inactive : styles.active),
        }}
        title="Residential CRM"
      >
        <span style={styles.icon}>🏠</span>
        <span style={styles.label}>Res</span>
      </button>
      <button
        onClick={() => handleToggle('government')}
        style={{
          ...styles.button,
          ...(isGovernment ? styles.active : styles.inactive),
        }}
        title="Government Contracting"
      >
        <span style={styles.icon}>🏛️</span>
        <span style={styles.label}>Gov</span>
      </button>
    </div>
  );
};

const styles: { [key: string]: React.CSSProperties } = {
  container: {
    display: 'flex',
    backgroundColor: '#1a2634',
    borderRadius: 8,
    padding: 4,
    gap: 4,
  },
  button: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 6,
    padding: '6px 12px',
    minWidth: 70,
    border: 'none',
    borderRadius: 6,
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    fontWeight: 600,
    fontSize: 13,
    whiteSpace: 'nowrap',
  },
  active: {
    backgroundColor: '#4A7EB5',
    color: '#ffffff',
  },
  inactive: {
    backgroundColor: 'transparent',
    color: '#94a3b8',
  },
  icon: {
    fontSize: 16,
  },
  label: {
    letterSpacing: '0.3px',
  },
};

export default DivisionToggle;
